import { datadogRum } from '@datadog/browser-rum'
import {
  createEventServiceClient,
  EventServiceClient,
} from '@thyme/libs/src/events/eventServiceClient'
import { MonitoringEvent } from './types'

// BE requires sessionId, so fall back to this when datadog RUM has no active session.
export const SESSION_ID_PLACEHOLDER = '00000000-0000-0000-0000-000000000000'

let client: EventServiceClient | null = null

// Current user's entityId, synced by useEventServiceUser (mirrors useDatadogUser).
// Sent as userId on every event; the backend maps it to the staff record.
let currentUserId: string | null = null

/**
 * Sets the actor id sent with subsequent events. Pass null to clear on logout.
 * @param userId
 */
export function setEventServiceUserId(userId: string | null): void {
  currentUserId = userId
}

/**
 *
 * @param opts
 * @param opts.eventService
 * @param opts.eventService.url
 * @param opts.eventService.apiKey
 * @param opts.isLocal
 */
// IMPROVEME(TEA-1018): no-ops until eventService config is wired with real values
export function initializeEventService(opts: {
  eventService?: { url: string; apiKey: string }
  isLocal: boolean
}): void {
  if (!opts.eventService) {
    console.debug('Skipping event service initialization (not configured)')
    return
  }
  client = createEventServiceClient({
    url: opts.eventService.url,
    apiKey: opts.eventService.apiKey,
    isLocal: opts.isLocal,
  })
}

/**
 *
 * @param event
 */
export async function sendMonitoringEvent(
  event: MonitoringEvent
): Promise<void> {
  if (!client) return
  const sessionId =
    datadogRum.getInternalContext()?.session_id ?? SESSION_ID_PLACEHOLDER
  await client.sendEvent(event.event, event.data, {
    sessionId,
    ...(currentUserId && { userId: currentUserId }),
  })
}
